// extracted by mini-css-extract-plugin
export default {"actions":"style_actions__sRcHF","actions_btn":"style_actions_btn__DOF1p"};